import React from "react";

import { Col, Input, LinkMoreInfo, Row, Typography } from "components";

export const AddressInformation = ({ addressStreet, details, farmCode, setAddressStreet, t, setToggleModalFarmNumber, toggleModalFarmNumber }) => {
  let streetName = "";
  let streetNumber = "";
  if (addressStreet) {
    const groups = addressStreet.split(/(\d+)(?!.*\d)/);
    // eslint-disable-next-line prefer-destructuring
    streetName = groups[0].trim(); // shouldn't match streets with numbers in, such as Strasse des 17. Juli
    streetNumber = [groups[1], groups[2]].join("").trim(); // allow for address suffixes like "143b"
  }

  return (
    <>
      <Row>
        <Col>
          <Row gutter={0}>
            <Col>
              <Typography variant="h2" className="margin-bottom-250">
                {t("addressHeadline")}
              </Typography>
            </Col>
          </Row>
          <Input name="addressName" label={t("addressName")} rules={[{ required: true }]} initialValue={details.addressName} />
        </Col>
      </Row>
      <Row>
        <Col sm={24} md={24}>
          <Input
            name="code"
            label={t("onboarding:farmDetails.code")}
            rules={[{ required: true, min: 12, max: 18 }]}
            initialValue={farmCode || undefined}
            className="no-suffix"
            placeholder={t("onboarding:farmDetails.codePlaceholder")}
          />
        </Col>
      </Row>
      <Row>
        <Col className="padding-top-0">
          <LinkMoreInfo onClick={() => setToggleModalFarmNumber(!toggleModalFarmNumber)}>{t("onboarding:farmDetails.whereFarmNr")}</LinkMoreInfo>
        </Col>
      </Row>
      <Row>
        <Col sm={18} md={18}>
          <Input
            name="addressStreetName"
            label={t("addressStreet")}
            rules={[{ required: true }]}
            initialValue={streetName}
            onChange={(v) => setAddressStreet(`${v.target.value} ${streetNumber}`)}
          />
        </Col>
        <Col sm={6} md={6}>
          <Input
            name="addressStreetNumber"
            label={t("addressNumber")}
            rules={[{ required: true }]}
            initialValue={streetNumber}
            onChange={(v) => setAddressStreet(`${streetName} ${v.target.value}`)}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={12}>
          <Input name="addressZip" label={t("addressZip")} rules={[{ required: true }]} initialValue={details.addressZip} />
        </Col>
        <Col sm={12} md={12}>
          <Input name="addressCity" label={t("addressCity")} rules={[{ required: true }]} initialValue={details.addressCity} />
        </Col>
      </Row>
    </>
  );
};
